import React from 'react';
import { motion } from 'framer-motion';
export function Quote() {
  return <section className="py-24 bg-usa-navy relative overflow-hidden" data-id="element-181">
      {/* Background accents */}
      <div className="absolute inset-0 opacity-10" data-id="element-182">
        <div className="absolute top-0 left-0 w-full h-full" style={{
        backgroundImage: 'radial-gradient(circle at 2px 2px, white 1px, transparent 0)',
        backgroundSize: '40px 40px'
      }} data-id="element-183"></div>
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10" data-id="element-184">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} data-id="element-185">
          <span className="inline-block text-xs font-bold text-usa-red uppercase tracking-[0.3em] mb-6 px-4 py-1.5 border border-usa-red/50" data-id="element-186">
            Cyrus's Favorite Quote
          </span>
          <span className="text-usa-red font-display text-6xl md:text-8xl leading-none block mb-4" data-id="element-187">
            "
          </span>
          <blockquote className="text-2xl md:text-4xl font-display font-medium text-white leading-snug mb-6 tracking-wide" data-id="element-188">
            KNOWLEDGE WILL GIVE YOU POWER, BUT CHARACTER RESPECT.
          </blockquote>
          <cite className="text-usa-gold font-display text-xl tracking-widest not-italic block mb-8" data-id="element-189">
            — BRUCE LEE
          </cite>
          <p className="text-gray-400 text-sm md:text-base max-w-xl mx-auto italic leading-relaxed" data-id="element-190">
            A reminder Cyrus carries with him on and off the mat — that real
            strength is built on character, not just skill.
          </p>
        </motion.div>
      </div>
    </section>;
}